import { TableCell } from "@mui/material"
import { useCallback, useState } from "react";
import { TConfiguracaoBancaria } from "../../../../../types/api/financeiro/configuracoes-bancarias";
import DialogCriacaoEditConfiguracoesBancarias from "./DialogCriacaoEditConfiguracoesBancarias";
import SessaoConfiguracao, { ConfiguracaoColunas } from "../../../../../components/BasicComponents/DisplayDados/SessaoConfiguracao";

export default function ConfiguracoesBancarias() {

    const [openModal, setOpenModal] = useState<TOpenModalConfigBancarias>(null)

    //funções manipuladoras
    const handleModalAction = useCallback((action: "open" | "close", id?: true | number, value?: TConfiguracaoBancaria | null) => {
        if (action === "close") setOpenModal(null)
        if (action === "open" && id && value) setOpenModal({ open: id, defaultValue: value })
        if (action === "open" && id && !value) setOpenModal({ open: id, defaultValue: null })
    }, [])
    //
    return (
        <>
            <SessaoConfiguracao<TConfiguracaoBancaria>
                titulo="Configurações bancárias"
                endpoints={{
                    listar: "financeiro/configuracoes/pesquisar-configuracoes-bancarias",
                    deletar: "financeiro/configuracoes/excluir-configuracao-bancaria",
                }}
                colunas={colunas}
                queryKey="pesquisar-configuracoes-bancarias"
                onEditar={(config) => {
                    handleModalAction("open", config.id, config)
                }}
                onAdicionar={() => {
                    handleModalAction("open", true, null)
                }}
                mensagemSucessoDeletar="Exclusão da configuração realizada com sucesso!"
                mensagemErroDeletar="Erro ao excluir configuração bancária!"
                mensagemSemDados="Nenhuma configuração bancária encontrada."
            />

            {
                Boolean(openModal?.open) &&
                <DialogCriacaoEditConfiguracoesBancarias
                    defaultValue={openModal?.defaultValue ? openModal : null}
                    open={Boolean(openModal?.open)}
                    handleClose={() => handleModalAction("close")}
                />
            }

        </>
    )
}

export type TOpenModalConfigBancarias = {
    open: number | boolean | null;
    defaultValue: TConfiguracaoBancaria | null;
} | null

const colunas: ConfiguracaoColunas<TConfiguracaoBancaria>[] = [
    {
        campo: "nome_banco",
        titulo: "Banco",
    },
    {
        campo: "agencia",
        titulo: "Agência",
        render: (_, config) => (
            <TableCell align="left" component="th" scope="row">
                {config.agencia}{config.agencia_digito ? `-${config.agencia_digito}` : ''}
            </TableCell>
        )
    },
    {
        campo: "conta",
        titulo: "Conta",
        render: (_, config) => (
            <TableCell align="left" component="th" scope="row">
                {config.conta}{config.conta_digito ? `-${config.conta_digito}` : ''}
            </TableCell>
        ),
    }
];